import NormalisedEvent from '../schema/NormalisedEvent';
import TimeConstants from 'mini-datetime-utils/lib/dateValues/TimeConstants';
import { CalendarEvent } from 'mini-calendar-event-types';
import { getTimestamp, userDate } from 'owa-datetime';

const MIN_MILLISECOND_DURATION: number = 30 * TimeConstants.MillisecondsIn1Min;

/**
 * Takes a set of events and normalises them if their duration is less than 30 min, encapsulating the event in it as a composition
 * @param events
 */
const normaliseEvents = (events: CalendarEvent[]): NormalisedEvent[] =>
    events
        ? events.map(
              (event: CalendarEvent) =>
                  ({
                      event,
                      start: event.Start,
                      end:
                          event.durationInMs() < MIN_MILLISECOND_DURATION
                              ? userDate(getTimestamp(event.Start) + MIN_MILLISECOND_DURATION)
                              : event.End,
                  } as NormalisedEvent)
          )
        : [];

export default normaliseEvents;
